// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2wf0T","content":"styles_content__16fxQ","selectAll":"styles_selectAll__2cPF4"};